// extracted by mini-css-extract-plugin
export default {"category-selection":"+DpK2txiCwfgckfUvccj2A==","selected":"_5AHiMOzpetqclhEGCF8sOw==","games":"X089Dxtxwe1HrWoJM5s5yQ=="};